import React from 'react'
import PhoneArrayField from '../../components/PhoneArrayField'
import EmailArrayField from '../../components/EmailArrayField'
import { Show, SimpleShowLayout, TextField } from 'react-admin'
import {BackToOrgButton, ShowOrgButton} from '../../components/Organization/OrgButtons.js'
import { parse } from "query-string";

const ContactShow = (props) => {

    const { organization_id } = parse(props.location.search);
    return (
        <Show {...props} title="Contact">
            <SimpleShowLayout>
                <BackToOrgButton organization_id={organization_id} />
                <ShowOrgButton />
                <TextField source="firstName" />
                <TextField source="lastName" />
                <PhoneArrayField source="phone" {...props} />
                <EmailArrayField source="email" {...props} />
            </SimpleShowLayout>
        </Show>
    );
}

export default ContactShow